import {Component, HostListener, OnInit, Output, Input} from '@angular/core';
import {CalendarTodayService} from "../../Services/calendar-today/calendar-today.service";
import * as format from "date-fns/format";
import * as startOfMonth from "date-fns/start_of_month";
import * as endOfMonth from "date-fns/end_of_month";
import * as getDay from "date-fns/get_day";
import * as subDays from "date-fns/sub_days";
import * as getDaysInMonth from "date-fns/get_days_in_month";
import * as addMonths from "date-fns/add_months";
import * as addDays from "date-fns/add_days";
import * as subMonths from "date-fns/sub_months";
import * as isToday from "date-fns/is_today";
import * as getMonth from 'date-fns/get_month'
import * as getYear from 'date-fns/get_year'
import * as parse from 'date-fns/parse'
import * as setDate from 'date-fns/set_date';
import * as getDate from 'date-fns/get_date';
import * as isThisMonth from 'date-fns/is_this_month';
import {TimezoneService} from "../../Services/timezone/timezone.service";
import {
  ChronoField, DateTimeFormatter, DateTimeFormatterBuilder, IsoFields, LocalDate, LocalDateTime, LocalTime,
  nativeJs, TemporalField, ZonedDateTime, ZoneOffset,
} from "js-joda";
import {Timezone} from "../../Models/Timezone";
import {ContactInfoService} from "../../Services/contact-info/contact-info.service";
import {AppointmentsService} from "../../Services/appointments/appointments.service";
import {Observable} from "rxjs/Observable";
import 'rxjs/add/operator/merge';
import 'rxjs/add/observable/merge';
import EventEmitter = NodeJS.EventEmitter;
import {DesktopTimezoneSelectorComponent} from "../desktop-timezone-selector/desktop-timezone-selector.component";
import {DesktopEditInfoComponent} from "../desktop-edit-info/desktop-edit-info.component";
import {DesktopCancelDemoComponent} from "../desktop-cancel-demo/desktop-cancel-demo.component";
import {DesktopAddToCalendarComponent} from "../desktop-add-to-calendar/desktop-add-to-calendar.component";
import {CookieService} from 'angular2-cookie/services/cookies.service';
import {addStylesToBlock, scrollToElement} from '../../helpers';
// import {CapitalizePipe} from '../../capitalize.pipe';

// Production steps of ECMA-262, Edition 5, 15.4.4.17
// Reference: http://es5.github.io/#x15.4.4.17
if (!Array.prototype.some) {
  Array.prototype.some = function (fun/*, thisArg*/) {
    'use strict';
    if (this == null) {
      throw new TypeError('Array.prototype.some called on null or undefined');
    }
    if (typeof fun !== 'function') {
      throw new TypeError();
    }
    var t = Object(this);
    var len = t.length >>> 0;
    var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
    for (var i = 0; i < len; i++) {
      if (i in t && fun.call(thisArg, t[i], i, t)) {
        return true;
      }
    }
    return false;
  };
}

@Component({
  selector: 'app-desktop-calendar',
  templateUrl: './desktop-calendar.component.html',
  styleUrls: ['./desktop-calendar.component.scss']
})
export class DesktopCalendarComponent implements OnInit {
  timezoneComponent      = DesktopTimezoneSelectorComponent;
  editComponent          = DesktopEditInfoComponent;
  cancelComponent        = DesktopCancelDemoComponent;
  addToCalendarComponent = DesktopAddToCalendarComponent;
  timezoneSelectOpen = false;
  editOpen = false;
  cancelDemo = false;
  addToCalendar = false;
  mainResult = null;
  selectedVal: { dateTime: ZonedDateTime, timezone: Timezone } = null;
  selectedJoda: LocalDate;
  responsive: Boolean = false;

  todayService: CalendarTodayService;
  timezoneService: TimezoneService;
  contactInfo: ContactInfoService;
  appointmentService: AppointmentsService;

  weekTimes = {};
  monthTimes = {};

  HOUR_OF_DAY = ChronoField.HOUR_OF_DAY;
  getDate = getDate;
  getMonth = getMonth;
  getYear = getYear;
  format = format;
  startOfMonth = startOfMonth;
  endOfMonth = endOfMonth;
  getDay = getDay;
  subDays = subDays;
  getDaysInMonth = getDaysInMonth;
  isThisMonth = isThisMonth;
  isToday = isToday;
  parse = parse;
  addDays = addDays;
  addMonths = addMonths;
  subMonths = subMonths;
  ofPattern = DateTimeFormatter.ofPattern;
  emptyContacts = false;
  emptyTime = false;
  isReschedule = '';
  cookieDate1 = '';
  cookieDate2 = '';
  userFirstName = '';
  userLastName = '';
  userPhone = '';
  userEmail = '';
  userCompany = '';
  userWebsite = '';
  isResult = false;
  isCanceled = '';
  gotomeeting_url = '';
  gotomeeting_us = '';
  gotomeeting_code = '';
  googleLink = undefined;
  outlook = undefined;
  disabledWeek = true;
  isAgencyTrue = false;
  formID = '';
  confirmation_text1 = '';
  confirmation_text2 = '';
  confirmation_text3 = '';
  monthStart;
  monthDays;
  daysToMondey;
  monthly = 'no';
  currentMonthCurrentDay;
  textGreen = '';
  textOrange = '';
  aptMinutes = '60';

  weekConvert = {
    0: 'Sun',
    1: 'Mon',
    2: 'Tue',
    3: 'Wed',
    4: 'Thu',
    5: 'Fri',
    6: 'Sat',
    7: 'Sun',
  };
  weekConvertFull = {
    '0': 'Sunday',
    '1': 'Monday',
    '2': 'Tuesday',
    '3': 'Wednesday',
    '4': 'Thursday',
    '5': 'Friday',
    '6': 'Saturday',
    '7': 'Sunday',
  };
  monthConvertFull = {
    1: 'January',
    2: 'February',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December',
  };
  convertTimeIndex = [
    LocalTime.of(0),
    LocalTime.of(0, 30),
    LocalTime.of(1),
    LocalTime.of(1, 30),
    LocalTime.of(2),
    LocalTime.of(2, 30),
    LocalTime.of(3),
    LocalTime.of(3, 30),
    LocalTime.of(4),
    LocalTime.of(4, 30),
    LocalTime.of(5),
    LocalTime.of(5, 30),
    LocalTime.of(6),
    LocalTime.of(6, 30),
    LocalTime.of(7),
    LocalTime.of(7, 30),
    LocalTime.of(8),
    LocalTime.of(8, 30),
    LocalTime.of(9),
    LocalTime.of(9, 30),
    LocalTime.of(10),
    LocalTime.of(10, 30),
    LocalTime.of(11),
    LocalTime.of(11, 30),
    LocalTime.of(12),
    LocalTime.of(12, 30),
    LocalTime.of(13),
    LocalTime.of(13, 30),
    LocalTime.of(14),
    LocalTime.of(14, 30),
    LocalTime.of(15),
    LocalTime.of(15, 30),
    LocalTime.of(16),
    LocalTime.of(16, 30),
    LocalTime.of(17),
    LocalTime.of(17, 30),
    LocalTime.of(18),
    LocalTime.of(18, 30),
    LocalTime.of(19),
    LocalTime.of(19, 30),
    LocalTime.of(20),
    LocalTime.of(20, 30),
    LocalTime.of(21),
    LocalTime.of(22, 30),
    LocalTime.of(23),
    LocalTime.of(23, 30),
  ];

  someEquals(arr, arg: LocalTime) {
    return arr.some((x) => x.equals(arg));
  }

  createAppointment(reschedule='') {
    // form validation
    let error = false;
    let inps = document.getElementsByClassName('edit-info-inp');
    for ( var i = 0; i < inps.length; i++ ) {
      let inp = <HTMLInputElement>inps[i];

      if ( inp.value.length < 1 ) {
        inp.classList.add('err');
        error = true;
      } else {
        inp.classList.remove('err');
      }

      if ( inp.type === 'email' ) {
        let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        let emailDomain = inp.value.split('@')[1];
        if ( !regex.test( inp.value ) || emailDomain === undefined || (this.contactInfo.freeEmailProviders !== [] && this.contactInfo.freeEmailProviders.includes(emailDomain)) ) {
          inp.classList.add('err');
          error = true;
        } else {
          inp.classList.remove('err');
        }
      }

      if ( inp.type === 'tel' ) {
        // let regex = /^(\d+-?|\d+\s?)+\d+$/;
        let regex1 = new RegExp(/(.)(\1){9,}/);
        let regex2 = new RegExp(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3,4}[-\s\.]?[0-9]{4,6}$/,"i");
        if ( regex1.test( inp.value ) || !regex2.test( inp.value ) ) {
          inp.classList.add('err');
          error = true;
        } else {
          inp.classList.remove('err');
        }
      }

      if ( inp.name === 'website' ) {
        let regex = new RegExp(/^(((http|https):\/{2})?(([0-9a-z_-]+\.)+(aero|asia|biz|cat|com|company|coop|edu|gov|info|int|jobs|mil|mobi|museum|name|net|org|pro|tel|travel|ac|ad|ae|af|ag|ai|al|am|an|ao|aq|ar|as|at|au|aw|ax|az|ba|bb|bd|be|bf|bg|bh|bi|bj|bm|bn|bo|br|bs|bt|bv|bw|by|bz|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|co|cr|cu|cv|cx|cy|cz|cz|de|dj|dk|dm|do|dz|ec|ee|eg|er|es|et|eu|fi|fj|fk|fm|fo|fr|ga|gb|gd|ge|gf|gg|gh|gi|gl|gm|gn|gp|gq|gr|gs|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|im|in|io|iq|ir|is|it|je|jm|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|me|mg|mh|mk|ml|mn|mn|mo|mp|mr|ms|mt|mu|mv|mw|mx|my|mz|na|nc|ne|nf|ng|ni|nl|no|np|nr|nu|nz|nom|pa|pe|pf|pg|ph|pk|pl|pm|pn|pr|ps|pt|pw|py|qa|re|ra|rs|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|sj|sk|sl|sm|sn|so|sr|st|su|sv|sy|sz|tc|td|tf|tg|th|tj|tk|tl|tm|tn|to|tp|tr|tt|tv|tw|tz|ua|ug|uk|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|yt|yu|za|zm|zw|xyz|arpa)(:[0-9]+)?((\/([~0-9a-zA-Z\#\+\%@\.\/_-]+))?(\?[0-9a-zA-Z\+\%@\/&\[\];=_-]+)?)?))\b$/,"i");
        if ( !regex.test( inp.value ) ) {
          inp.classList.add('err');
          error = true;
        } else {
          inp.classList.remove('err');
        }
      }
    }
    // check that date is selected
    if ( this.mainResult === null ) {
      this.emptyTime = true;
      error = true;
    } else {
      this.emptyTime = false;
    }
    if ( error ) {
      return;
    }
    document.getElementById('loader').classList.add('show');
    let contacts = this.contactInfo.getContactInfo();
    let date = this.mainResult.toString() + ':00' + window['appointmentTimezone'];

    if ( reschedule === '' || reschedule === undefined ) {
      this.appointmentService.createAppointment(date, contacts).subscribe((response) => {
        if ( response ) {
          this.lastStep();
        }
      });
    } else {
      this.appointmentService.reschedule(date).subscribe((response) => {
        if ( response ) {
          this.lastStep();
        }
      });
    }
  }

  safeGetWeekTimes(date: LocalDate) {
    if (this.weekTimes.hasOwnProperty(date.toString())) {
      return this.weekTimes[date.toString()]
    } else {
      return [];
    }
  }

  safeGetMonthTimes(date: LocalDate) {
    if (this.monthTimes.hasOwnProperty(date.toString())) {
      return this.monthTimes[date.toString()]
    } else {
      return [];
    }
  }

  constructor(today: CalendarTodayService, timezoneService: TimezoneService, contactInfo: ContactInfoService, appointmentService: AppointmentsService) {
    this.todayService = today;
    this.timezoneService = timezoneService;
    this.contactInfo = contactInfo;
    this.appointmentService = appointmentService;
    this.userFirstName = CookieService.prototype.get('firstName');
    this.userLastName = CookieService.prototype.get('lastName');
    this.userPhone = CookieService.prototype.get('phone');
    this.userEmail = CookieService.prototype.get('email');
    this.userCompany = CookieService.prototype.get('company');
    this.userWebsite = CookieService.prototype.get('website');

    if ( window['ngRoot'] !== null ) {
      this.isAgencyTrue = Boolean(window['ngRoot'].getAttribute('data-agency'));
      this.confirmation_text1 = window['ngRoot'].getAttribute('data-confirm1') || '';
      this.confirmation_text2 = window['ngRoot'].getAttribute('data-confirm2') || '';
      this.confirmation_text3 = window['ngRoot'].getAttribute('data-confirm3') || '';
      this.monthly = window['ngRoot'].getAttribute('data-monthly') || 'no';
      this.textGreen = window['ngRoot'].getAttribute('data-text-green') || '';
      this.textOrange = window['ngRoot'].getAttribute('data-text-orange') || '';
      this.aptMinutes = window['ngRoot'].getAttribute('data-minutes') || '60';
    }

    let currentAPT = CookieService.prototype.get('currentAPT');
    if ( currentAPT === window['appointmentType'] ) {
      this.isReschedule = CookieService.prototype.get('appointmentID');
      let userAppointmentDate = CookieService.prototype.get('appointmentDate');
      if ( userAppointmentDate !== '' && userAppointmentDate !== undefined ) {
        let cd = new Date(userAppointmentDate.replace(/..$/, ':00'));
        let tm = userAppointmentDate.split('T')[1].split(':');
        let tm_hours1 = parseInt(tm[0]);
        let tm_hours2 = tm_hours1;
        let tm_minutes1 = parseInt(tm[1]);
        let tm_minutes2 = tm_minutes1;
        let mmm = parseInt(this.aptMinutes);
        if (mmm > 0 && mmm % 60 === 0) {
          tm_hours2 += (mmm / 60);
        } else {
          tm_minutes2 += mmm;
          if (tm_minutes2 > 59) {
            let plus_hours = Math.floor(tm_minutes2 / 60);
            tm_minutes2 = tm_minutes2 - 60 * plus_hours;
            tm_hours2 += plus_hours;
          }
        }
        if (tm_hours2 > 23) {
          tm_hours2 = tm_hours2 - 24 * Math.floor(tm_hours2 / 24);
        }
        this.cookieDate1 = this.formatAMPM( false, '', tm_hours1.toString(), tm_minutes1.toString() ) + ' - ' + this.formatAMPM( true, tm_hours2 + ':' + tm_minutes2 );
        this.cookieDate2 = 'on ' + this.weekConvertFull[cd.getDay()] + ', ' + this.monthConvertFull[cd.getMonth()+1] + ' ' + cd.getDate() + ', ' + cd.getFullYear();
      }
    }

    this.monthStart = startOfMonth(this.todayService.currentDate);
    this.currentMonthCurrentDay = this.shownDate(this.todayService.currentDate);
    this.setMonthDays();
  }

  @HostListener('window:resize')
  checkResponsive() {
    this.responsive = document.body.clientWidth > 800 && document.body.clientWidth <= 1024;
  }

  getOrdinal(num): string {
    let ones = num % 10;
    let tens = Math.floor(num / 10) % 10;
    let suff = null;
    if (tens == 1) {
      suff = "th";
    } else {
      switch (ones) {
        case 1 :
          suff = "st";
          break;
        case 2 :
          suff = "nd";
          break;
        case 3 :
          suff = "rd";
          break;
        default :
          suff = "th";
      }
    }
    return suff;
  }

  convertToAppointmentTime(i, j) {
    return LocalDate.from(nativeJs(addDays(this.todayService.currentDate, i))).atTime(this.convertTimeIndex[j]);
  }

  getAppointmentTime(i, j) {
    let result = LocalDate.from(nativeJs(addDays(this.todayService.currentDate, i))).atTime(this.convertTimeIndex[j]);
    return result;
  }

  ngOnInit() {
    this.checkResponsive();
    if (this.monthly === 'yes') {
      this.loadMonthTimes(this.currentMonthCurrentDay);
      // this.loadMonthTimes(this.monthStart);
    } else {
      this.loadWeekTimes(this.todayService.currentDate);
    }
    this.isCanceled = window.location.search.split('cancel=')[1];
    this.hideHelpers();

    // disable prev week
    let tmp_date1 = new Date();
    let resp = this.responsive ? 6 : 7;
    let tmp_date2 = subDays(this.todayService.currentDate, resp);
    tmp_date1.setHours(0,0,0,0);
    tmp_date2.setHours(0,0,0,0);
    let tmp_diff = tmp_date1.getTime() - tmp_date2.getTime();
    if ( tmp_diff / 86400000 < resp - 1 ) {
      this.disabledWeek = false;
    }

    if ( window['ngRoot'] !== null ) {
      this.formID = window['ngRoot'].getAttribute('data-formid');
    }
  }

  loadWeekTimes(currentDate: Date) {
    let current: LocalDate = LocalDate.from(nativeJs(currentDate));
    let obs: Observable<{date:LocalDate, timesArr:LocalTime[]}>[] = [];
    for (let i of [0, 1, 2, 3, 4, 5, 6]) {
      let date = current.plusDays(i);
      // if ( !this.weekTimes.hasOwnProperty( ( date.toString() ) ) ) {
        obs.push(this.appointmentService.getTimes(date).map((timesArr) => {
          return {date: date, timesArr: timesArr}
        }));
      // }
    }
    Observable.merge(...obs).subscribe((obj) => {
      this.weekTimes[ obj.date.toString() ] = obj.timesArr;
    });
  }

  loadMonthTimes(currentDate: Date) {
    let current: LocalDate = LocalDate.from(nativeJs(currentDate));
    let obs: Observable<{date:LocalDate, timesArr:LocalTime[]}>[] = [];
    for (let i of this.monthDays) {
      let date = current.plusDays(i);
      obs.push(this.appointmentService.getTimes(date).map((timesArr) => {
        return {date: date, timesArr: timesArr}
      }));
    }
    Observable.merge(...obs).subscribe((obj) => {
      this.monthTimes[ obj.date.toString() ] = obj.timesArr;
    });
  }

  forward() {
    this.disabledWeek = false;
    if (this.monthly === 'yes') {
      this.monthStart = startOfMonth(addMonths(this.monthStart, 1));
      this.loadMonthTimes(this.monthStart);
    } else {
      this.todayService.currentDate = this.responsive ? addDays(this.todayService.currentDate, 6) : addDays(this.todayService.currentDate, 7);
      this.loadWeekTimes(this.todayService.currentDate);
    }
    this.setMonthDays();
  }

  back() {
    // do not show past dates
    if (this.monthly === 'yes') {
      this.disabledWeek = true;
      let tmp_monthStart1 = startOfMonth(new Date());
      let tmp_monthStart2 = startOfMonth(subMonths(this.monthStart, 1));
      if (tmp_monthStart1.getTime() <= tmp_monthStart2.getTime()) {
        this.monthStart = tmp_monthStart2;
        // load prev month
        if (isThisMonth(this.monthStart)) {
          this.loadMonthTimes(this.currentMonthCurrentDay);
        } else {
          this.loadMonthTimes(this.monthStart);
        }
        this.disabledWeek = false;
        // disable prev month
        tmp_monthStart2 = startOfMonth(subMonths(this.monthStart, 1));
        if (tmp_monthStart1.getTime() > tmp_monthStart2.getTime()) {
          this.disabledWeek = true;
        }
      }
    } else {
      this.disabledWeek = true;
      let tmp_date1 = new Date();
      let resp = this.responsive ? 6 : 7;
      let tmp_date2 = subDays(this.todayService.currentDate, resp);
      tmp_date1.setHours(0,0,0,0);
      tmp_date2.setHours(0,0,0,0);
      let tmp_diff = tmp_date1.getTime() - tmp_date2.getTime();
      if ( tmp_diff / 86400000 < resp - 1 ) {
        // load prev week
        this.todayService.currentDate = tmp_date2;
        this.loadWeekTimes(this.todayService.currentDate);
        // disable prev week
        tmp_date2 = subDays(this.todayService.currentDate, resp);
        tmp_diff = tmp_date1.getTime() - tmp_date2.getTime();
        if ( tmp_diff / 86400000 < resp - 1 ) {
          this.disabledWeek = false;
        }
      }
    }
    this.setMonthDays();
  }

  addActiveClass(event:any){
    event.preventDefault();
    var day_elems = document.getElementsByClassName( 'day' );
    for (var i = 0; i < day_elems.length; ++i) {
      day_elems[i].classList.remove('active');
    }
    event.target.classList.add('active');
  }

  myRerender() {
  	this.todayService.currentDate = new Date();
    if (this.monthly === 'yes') {
      if (isThisMonth(this.monthStart)) {
        this.loadMonthTimes(this.currentMonthCurrentDay);
      } else {
        this.loadMonthTimes(this.monthStart);
      }
    } else {
      this.loadWeekTimes(this.todayService.currentDate);
    }
  	return true;
  }

  getDayOfWeek(dateString){
    return LocalDateTime.of( dateString._year, dateString._month, dateString._day ).dayOfWeek();
    // return this.weekConvertFull[ new Date(dateString).getDay() ];
  }

  get1moreTime(timeString){
    let timeArray = timeString.toString().split(':');
    if ( parseInt(timeArray[1]) + 30 === 60 ) {
      return (parseInt(timeArray[0]) + 1) + ':00';
    } else {
      return timeArray[0] + ':30';
    }
  }

  appointmentCanceledHide(event){
    event.preventDefault();
    event.target.parentElement.classList.remove('show');
  }
  appointmentRescheduledHide(event){
    event.preventDefault();
    event.target.parentElement.classList.remove('show');
  }

  // you can pass string as '12:00' OR vars as h='12', m='0'
  formatAMPM(isStr = true, timeStr = '', h = '0', m = '0') {
    if ( isStr ) {
      var timeStrArr = timeStr.split(':'),
          hours = parseInt(timeStrArr[0]),
          minutes = parseInt(timeStrArr[1]);
    } else {
      var hours = parseInt(h),
          minutes = parseInt(m);
    }
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12;
    if ( minutes < 10 ) {
      var minutesStr = '0' + minutes;
    } else {
      var minutesStr = minutes + '';
    }
    return hours + ':' + minutesStr + ampm;
  }

  onKeyUp(event: any) {
    if ( event.target.value.length < 1 ) {
      event.target.classList.add('err');
      event.target.parentElement.classList.remove('qerr2');
      event.target.parentElement.classList.add('qerr1');
    } else {
      event.target.classList.remove('err');
      event.target.parentElement.classList.remove('qerr1');
    }
  }

  onKeyUpPhone(event: any) {
    if ( event.target.value.length < 1 ) {
      event.target.classList.add('err');
      event.target.parentElement.classList.remove('qerr2');
      event.target.parentElement.classList.add('qerr1');
    } else {
      event.target.classList.remove('err');
      event.target.parentElement.classList.remove('qerr1');
      event.target.parentElement.classList.remove('qerr2');

      // let regex = /^(\d+-?|\d+\s?)+\d+$/;
      let regex1 = new RegExp(/(.)(\1){9,}/);
      let regex2 = new RegExp(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3,4}[-\s\.]?[0-9]{4,6}$/,"i");
      if ( regex1.test( event.target.value ) || !regex2.test( event.target.value ) ) {
        event.target.classList.add('err');
        event.target.parentElement.classList.remove('qerr1');
        event.target.parentElement.classList.add('qerr2');
      } else {
        event.target.classList.remove('err');
        event.target.parentElement.classList.remove('qerr1');
        event.target.parentElement.classList.remove('qerr2');
      }
    }
  }

  onKeyUpEmail(event: any) {
    if ( event.target.value.length < 1 ) {
      event.target.classList.add('err');
      event.target.parentElement.classList.remove('qerr2');
      event.target.parentElement.classList.add('qerr1');
    } else {
      event.target.classList.remove('err');
      event.target.parentElement.classList.remove('qerr1');
      event.target.parentElement.classList.remove('qerr2');

      let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      let emailDomain = event.target.value.split('@')[1];
      if ( !regex.test( event.target.value ) || emailDomain === undefined || (this.contactInfo.freeEmailProviders !== [] && this.contactInfo.freeEmailProviders.includes(emailDomain)) ) {
        event.target.classList.add('err');
        event.target.parentElement.classList.remove('qerr1');
        event.target.parentElement.classList.add('qerr2');
      } else {
        event.target.classList.remove('err');
        event.target.parentElement.classList.remove('qerr1');
        event.target.parentElement.classList.remove('qerr2');
      }
    }
  }

  onKeyUpWebsite(event: any) {
    if ( event.target.value.length < 1 ) {
      event.target.classList.add('err');
      event.target.parentElement.classList.remove('qerr2');
      event.target.parentElement.classList.add('qerr1');
    } else {
      event.target.classList.remove('err');
      event.target.parentElement.classList.remove('qerr1');
      event.target.parentElement.classList.remove('qerr2');

      let regex = new RegExp(/^(((http|https):\/{2})?(([0-9a-z_-]+\.)+(aero|asia|biz|cat|com|company|coop|edu|gov|info|int|jobs|mil|mobi|museum|name|net|org|pro|tel|travel|ac|ad|ae|af|ag|ai|al|am|an|ao|aq|ar|as|at|au|aw|ax|az|ba|bb|bd|be|bf|bg|bh|bi|bj|bm|bn|bo|br|bs|bt|bv|bw|by|bz|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|co|cr|cu|cv|cx|cy|cz|cz|de|dj|dk|dm|do|dz|ec|ee|eg|er|es|et|eu|fi|fj|fk|fm|fo|fr|ga|gb|gd|ge|gf|gg|gh|gi|gl|gm|gn|gp|gq|gr|gs|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|im|in|io|iq|ir|is|it|je|jm|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|me|mg|mh|mk|ml|mn|mn|mo|mp|mr|ms|mt|mu|mv|mw|mx|my|mz|na|nc|ne|nf|ng|ni|nl|no|np|nr|nu|nz|nom|pa|pe|pf|pg|ph|pk|pl|pm|pn|pr|ps|pt|pw|py|qa|re|ra|rs|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|sj|sk|sl|sm|sn|so|sr|st|su|sv|sy|sz|tc|td|tf|tg|th|tj|tk|tl|tm|tn|to|tp|tr|tt|tv|tw|tz|ua|ug|uk|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|yt|yu|za|zm|zw|xyz|arpa)(:[0-9]+)?((\/([~0-9a-zA-Z\#\+\%@\.\/_-]+))?(\?[0-9a-zA-Z\+\%@\/&\[\];=_-]+)?)?))\b$/,"i");
      if ( !regex.test( event.target.value ) ) {
        event.target.classList.add('err');
        event.target.parentElement.classList.remove('qerr1');
        event.target.parentElement.classList.add('qerr2');
      } else {
        event.target.classList.remove('err');
        event.target.parentElement.classList.remove('qerr1');
        event.target.parentElement.classList.remove('qerr2');
      }
    }
  }

  ngAfterViewChecked() { // after content load
    if (this.monthly !== 'yes') {
      let ds = window['ngRoot'].querySelector('.days-selection');
      let right_part = window['ngRoot'].querySelector('.info');
      let header1 = window['ngRoot'].querySelector('.calendar-header');
      let header2 = window['ngRoot'].querySelector('.days');
      let header3 = window['ngRoot'].querySelector('.timezone');
      if (ds !== null && right_part !== null && header1 !== null && header2 !== null && header3 !== null) {
        ds.style.minHeight = (right_part.clientHeight-header1.clientHeight-header2.clientHeight-header3.clientHeight)+'px';
      }
    }
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////

  dateYYYYMMDD(date: Date) {
    var mm = date.getMonth() + 1,
        dd = date.getDate();
    return [date.getFullYear(), (mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd].join('-');
  }

  newSafeGet_WeekTimes(date: Date) {
    let yyyy_mm_ddd = this.dateYYYYMMDD(date);
    if ( this.weekTimes.hasOwnProperty( yyyy_mm_ddd ) ) {
      return this.weekTimes[yyyy_mm_ddd];
    } else {
      return [];
    }
  }

  newSafeGet_MonthTimes(date: Date) {
    let yyyy_mm_ddd = this.dateYYYYMMDD(date);
    if ( this.monthTimes.hasOwnProperty( yyyy_mm_ddd ) ) {
      return this.monthTimes[yyyy_mm_ddd];
    } else {
      return [];
    }
  }

  makeAppointmentTime(numDays, time) {
    return LocalDate.from(nativeJs(addDays(this.todayService.currentDate, numDays))).atTime(time);
  }

  makeAppointmentTime2(numDays, time) {
    let dt = this.monthStart;
    if (isThisMonth(this.monthStart)) {
      dt = this.currentMonthCurrentDay;
    }
    return LocalDate.from(nativeJs(addDays(dt, numDays))).atTime(time);
  }

  goReschedule() {
    this.isResult = false;
    this.isReschedule = window['appointmentID'];
    this.userFirstName = CookieService.prototype.get('firstName');
    this.userLastName = CookieService.prototype.get('lastName');
    this.userPhone = CookieService.prototype.get('phone');
    this.userEmail = CookieService.prototype.get('email');
    this.userCompany = CookieService.prototype.get('company');
    this.userWebsite = CookieService.prototype.get('website');

    addStylesToBlock('.popular-sharpspring-content', '');
    addStylesToBlock('#starter-steps', '');
    addStylesToBlock('.activation-title', '');
    // document.getElementById('acuitycal-container').scrollIntoView();
    scrollToElement('#acuitycal-container', -140);
  }

  lastStep() {
    this.hideHelpers();
    this.isResult = true;
    document.getElementById('loader').classList.remove('show');
    // document.getElementById('acuity-calc-desktop-result').scrollIntoView();
    scrollToElement('#acuity-calc-desktop-result', -140);
    let gotomeeting = CookieService.prototype.get('appointmentLocation');
    if ( gotomeeting !== undefined ) {
      let loc_arr = gotomeeting.split("\n");
      if ( loc_arr[0] !== undefined ) {
        this.gotomeeting_url = loc_arr[0].split(" ")[1];
      }
      if ( loc_arr[1] !== undefined ) {
        this.gotomeeting_us = loc_arr[1].split(": ")[1];
      }
      if ( loc_arr[2] !== undefined ) {
        this.gotomeeting_code = loc_arr[2].split(": ")[1];
      }
    }
    this.googleLink = CookieService.prototype.get('appointmentGoogle');
    this.outlook = CookieService.prototype.get('appointmentOutlook');

    let wrap = document.getElementsByClassName('no-angular-wrapper');
    if ( wrap.length > 0 ) {
      for ( let i = 0; i < wrap.length; i++ ) {
        wrap[i].setAttribute('style', 'display:none');
      }
    }
    addStylesToBlock('.popular-sharpspring-content', 'display: block');
    addStylesToBlock('#starter-steps', 'display: none');
    addStylesToBlock('.activation-title', 'display: none');
    // document.getElementById('acuitycal-container').scrollIntoView();
    scrollToElement('#acuitycal-container', -140);
  }

  hideHelpers() {
    setTimeout(() => {
      let a1 = document.getElementById('appointment-canceled');
      if ( a1 !== undefined && a1 !== null  ) {
        a1.classList.remove('show');
      }
      let a2 = document.getElementById('appointment-rescheduled');
      if ( a2 !== undefined && a2 !== null  ) {
        a2.classList.remove('show');
      }
    }, 6000);
  }

  setMonthDays():void {
    this.monthDays = Array( getDaysInMonth(this.monthStart) ).fill(0).map((x,i)=>i);
    let toMondeyDiff = 0;
    if (isThisMonth(this.monthStart)) {
      toMondeyDiff = getDay(this.currentMonthCurrentDay) - 1;
    } else {
      toMondeyDiff = getDay(this.monthStart) - 1;
    }
    let toMondey = toMondeyDiff > 1 ? toMondeyDiff : 1;
    this.daysToMondey = Array( toMondey ).fill(0).map((x,i)=>i+1);
  }

  shownDate(date:Date) {
    let dayDate = getDay(date);
    let nextDateDay = getDate(addDays(date, 1));
    let next2DateDay = getDate(addDays(date, 2));
    if ((dayDate === 0 || dayDate === 6) && (nextDateDay === 1 || next2DateDay === 1)) {
      if (dayDate === 0) {
        return subDays(date, 2);
      } else {
        return subDays(date, 1);
      }
    } else {
      if (nextDateDay === 1) {
        return date;
      } else {
        return addDays(date, 1);
      }
    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/Components/desktop-calendar/desktop-calendar.component.ts